<template>
   <div class="lookaddtop">
        <el-button @click="fanhuiclick"  size="medium ">返回</el-button>
        <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         v-loading="loading"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :border="true"
          stripe

          @selection-change="handleSelectionChange">
          <el-table-column
            prop="studentName"
            label="姓名"
            >
          </el-table-column>
          <el-table-column
          prop="className"
          label='班级'
          >
          </el-table-column>
          <el-table-column
            prop="score"
            label="成绩"
            >
          </el-table-column>
          <el-table-column
            prop="studentAnswer"
            label="答案"
            >
          </el-table-column> 
          <el-table-column
            prop="answer"
            label="正确答案"
            >
          </el-table-column> 
          <el-table-column
            prop="createdAt"
            label="提交时间"
            >
          </el-table-column>
        </el-table>

        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>
   </div>
</template>
<script>
import { roomLookList} from '@/assets/api/renyuan'

export default {
   name: '',
   components: {
     
   },
   props:['lookObj'],
   data() {
     return {
       pageInfo:{
        page:1,
        pageSize:10
       },
       tableData:[],
       total:''
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
    console.log(this.lookObj,'结果');
    this.lookList()
   },
   methods: {
    fanhuiclick(){
        console.log(8888);
        this.$emit('roomClickShow')
    },
    // 结果列表
    lookList(){
        const params = {
            page:this.pageInfo.page,
            pageSize:this.pageInfo.pageSize
        }
        roomLookList(params,this.lookObj.examId).then((res)=> {
            // console.log(res,'结果列表');
            this.tableData = res.data.data.list
            this.total = res.data.data.total

        }).catch((err) => {
            console.log(err,'结果列表');
        })
    }
    ,
    handleSizeChange (val) {
              console.log(`${val} items pr page`)
          },
          handleCurrentChange (val) {
            console.log(val,'11111111111111111111111');
            this.pageInfo.page = val
            this.lookList()
          },
   }
};
</script>
<style  scoped lang="scss">
 .lookaddtop{
    height: 100%;
    /deep/ .el-button {
        margin-left: 20px;
    }
    .fuzzy-matching-bottom {
    height: calc(100% - 170px);
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 10px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 8px;
    
    .top-first-line {
      height: 45px;
      line-height: 45px;
        /deep/ .tip-button {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        /deep/ .el-button--small {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      /deep/ {
        // .el-checkbox.el-checkbox--small .el-checkbox__inner {
        //   width: 18px;
        //   height: 18px;
        // }
        // .el-checkbox:last-of-type {
        //   margin-right: -1px;
        // }
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          font-size: 14px;
        }
         .manipulate {
          color: red;
          margin-right:15px;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
 }
</style>